import type { permissionType } from '@/features/tenant-manager/role/_models/role';
import { useId } from '@/hooks';
import { isPS } from '@/utils';
import type { FC, PropsWithChildren } from 'react';
import type { z } from 'zod';
import { useProjectPermissionAndAccessControl } from '../_hooks/permission';

const PublishedProjectGuard: FC<
  PropsWithChildren & {
    projectId: string;
    additionalAccessibleProjectRole:
      | z.infer<typeof permissionType>[]
      | undefined;
  }
> = ({ children, projectId, additionalAccessibleProjectRole }) => {
  const { hasAccessControlByOrganization, projectRole } =
    useProjectPermissionAndAccessControl(projectId);
  const hasPermission =
    hasAccessControlByOrganization ||
    (additionalAccessibleProjectRole &&
      projectRole &&
      additionalAccessibleProjectRole.includes(projectRole));

  return hasPermission ? <>{children}</> : null;
};

export const PublishedProjectMutableGuard: FC<
  PropsWithChildren & {
    additionalAccessibleProjectRole?: z.infer<typeof permissionType>[];
  }
> = ({ children, additionalAccessibleProjectRole }) => {
  const { id: projectId } = useId();

  // NOTE: For PS, to not let them edit.
  if (isPS() || !projectId) {
    return null;
  }

  return (
    <PublishedProjectGuard
      projectId={projectId}
      additionalAccessibleProjectRole={additionalAccessibleProjectRole}
    >
      {children}
    </PublishedProjectGuard>
  );
};
